import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div>
      <h1>Not found</h1>
      <p className="muted">
        We couldn&apos;t find what you were looking for. <Link to="/">Back home</Link>.
      </p>
    </div>
  );
}
